<template>
  <DashboardPage>
    <CategoryForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import CategoryForm from './components/CategoryForm.vue';

const route = useRoute()

</script>